import {configureStore} from '@reduxjs/toolkit';
import sideBarControler from './sideBar';

export const store = configureStore({
  reducer: {
    sideBarControler: sideBarControler,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
